import React, { useEffect, useState, useContext } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { BsEmojiSmile } from "react-icons/bs";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "react-calendar/dist/Calendar.css";
import { AiOutlineInfoCircle } from "react-icons/ai";
import DateTimeBox from "../../Components/DateTimeBox/Index";
import {
  haveValue,
  isValidDate,
  validateJOIFormField,
  validateJOIProperty,
} from "./../../utils/helpers";
import { useNavigate } from "react-router-dom";
import * as Joi from "joi-browser";
import FieldError from "./../../../src/Components/Common/FieldError";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ThemeContext } from "../../hooks/useThemeContext";
import { isEmpty } from "lodash";
import axios from "axios";
import useSoloEvent from "../../hooks/useSoloEvent";
import EventHeaderTitle from "./EventHeaderTitle";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { getEventDate } from "./../../utils/helpers";

const EventStep1 = (props) => {
  const location = useLocation();
  const eventFromState = location.state?.event;
  console.log(eventFromState, "eventFromState");

  const navigate = useNavigate();
  const { setBackUrlContext, showErrorToast } = useContext(ThemeContext);

  useEffect(() => {
    localStorage.removeItem("link");
    getLocation();
    setBackUrlContext("");
  }, []);

  // Open Others Popup
  const [showOtherbar, setOtherShow] = useState(false);
  const OtherClose = () => setOtherShow(false);
  const OtherShow = () => setOtherShow(true);
  const [alertShow, setAlertShow] = useState(false);
  const { event, setEvent } = props;

  const [errors, setErrors] = useState({});

  const [otherOccasion, setOtherOccasion] = useState("");

  const schema = {
    firstName: Joi.string().required().label("First Name"),
    lastName: Joi.string().required().label("Last Name"),
    occasionId: Joi.string().required().label("Occasion"),
  };

  const handleForm = (e, name) => {
    let fieldName = name;
    let fieldValue = e;
    let errorData = { ...errors };
    const errorMessage = validateJOIProperty(schema, fieldName, fieldValue);
    if (errorMessage) {
      errorData[fieldName] = errorMessage;
    } else {
      delete errorData[fieldName];
    }
    setErrors(errorData);
    console.log(fieldName, fieldValue);
    if (fieldName == "date") {
      setEvent((existingValue) => ({
        ...existingValue,
        ["eventRawDate"]: fieldValue,
      }));
    }
    if (fieldName == "time") {
      setEvent((existingValue) => ({
        ...existingValue,
        ["eventRawTime"]: fieldValue,
      }));
    }
    setEvent((existingValue) => ({
      ...existingValue,
      [fieldName]: fieldValue,
    }));
  };

  const eventstate2 = () => {
    if (!isValidDate(event?.date)) {
      if (isEmpty(event?.time)) {
        showErrorToast("Please select both Date & Time");
        return false;
      }
    }
    if (isEmpty(event?.time)) {
      showErrorToast("Please select time");
      return false;
    }
    console.log(
      moment(`${event?.date} ${event?.time}`).isBefore(moment()),
      moment(`${event?.date} ${event?.time}`)
    );
    if (moment(`${event?.date} ${event?.time}`).isBefore(moment())) {
      showErrorToast("Please select future Date & Time");
      return false;
    }
    let errors = validateJOIFormField(event, schema);
    if (errors == null) {
      // setAlertShow(true);
      navigate("/eventstep2");
    } else {
      setErrors(errors);
    }
  };

  const resetDateTime = (e) => {
    let fieldValue = "";
    setEvent((existingValue) => ({
      ...existingValue,
      date: fieldValue,
      time: fieldValue,
    }));

    let errors = validateJOIFormField(event, schema);
    console.log(errors, "CHECK ERRORS HERE");
    if (errors == null) {
      navigateStep2();
      // navigate('/eventstep2');
    } else {
      setErrors(errors);
    }
  };

  const navigateStep2 = () => {
    console.log("COMING HERE");
    navigate("/eventstep2");
  };

  const handleOtherOccasion = (val) => {
    setOtherOccasion(val);
    handleForm(val, "occasionId");
  };

  const handleOccasionChange = (val) => {
    setOtherOccasion("");
    handleForm(val, "occasionId");
  };

  const handleClosedateadded = () => {
    setAlertShow(false);
  };

  const occasionList = [
    {
      id: 1,
      name: "Birthday",
      svg: (
        <svg
          width="29"
          height="24"
          viewBox="0 0 29 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 1.37329V4.42662M1.5 15.7866C3.35333 15.7866 3.35333 16.7866 5.20667 16.7866C7.06 16.7866 7.06 15.7866 8.91333 15.7866C10.7667 15.7866 10.7667 16.7866 12.62 16.7866C14.4733 16.7866 14.4733 15.7866 16.3267 15.7866C18.18 15.7866 18.18 16.7866 20.0333 16.7866C21.8867 16.7866 21.8867 15.7866 23.7533 15.7866C25.62 15.7866 25.6067 16.7866 27.4733 16.7866M4.83333 10.56H24.1533C25.9933 10.56 27.4867 12.0533 27.4867 13.8933V22.0266H1.5V13.8933C1.5 12.0533 2.99333 10.56 4.83333 10.56ZM22.9933 10.56H5.99333V6.91996C5.99333 5.54662 7.11333 4.42662 8.48667 4.42662H20.5C21.8733 4.42662 22.9933 5.54662 22.9933 6.91996V10.56Z"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 2,
      name: "Wedding",
      svg: (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1766 21.6565C15.1394 20.9855 15.2139 20.3021 15.4002 19.6063C16.3568 16.0526 20.0092 13.9403 23.5621 14.897C27.1151 15.8538 29.227 19.5069 28.2704 23.0606C27.3139 26.6142 23.6615 28.7266 20.1085 27.7698M19.1673 21.3769C19.1425 25.055 16.1354 28.0248 12.4572 27.9999C8.77912 27.9751 5.80929 24.968 5.83414 21.2899C5.85899 17.6118 8.8661 14.6421 12.5442 14.6669C13.2028 14.6669 13.8365 14.7663 14.433 14.9527"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.2595 3.70654C19.7929 0.439875 25.5529 5.49321 19.3395 10.6132C18.4195 11.5199 17.4462 12.3465 16.3662 13.0399C16.2862 13.0932 16.2329 13.0799 16.1662 13.0399C14.7529 12.1865 13.5662 11.0132 12.4062 9.85321C11.7795 9.22654 11.2062 8.54654 10.8062 7.74654C8.93955 4.22654 13.4862 0.919876 16.2595 3.70654Z"
            fill="#E31B54"
          />
        </svg>
      ),
    },
    {
      id: 3,
      name: "House Warming",
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.3327 14.6667H23.7327C25.2262 14.6667 25.9729 14.6667 26.5433 14.9573C27.0451 15.213 27.453 15.6209 27.7087 16.1227C27.9993 16.6931 27.9993 17.4399 27.9993 18.9333V28M17.3327 28V8.26667C17.3327 6.77319 17.3327 6.02646 17.042 5.45603C16.7864 4.95426 16.3784 4.54631 15.8767 4.29065C15.3062 4 14.5595 4 13.066 4H8.26602C6.77254 4 6.02581 4 5.45537 4.29065C4.95361 4.54631 4.54566 4.95426 4.29 5.45603C3.99935 6.02646 3.99935 6.77319 3.99935 8.26667V28M29.3327 28H2.66602M8.66602 9.33333H12.666M8.66602 14.6667H12.666M8.66602 20H12.666"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 4,
      name: "Baby Shower",
      svg: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0003 1.66675C7.63653 1.66675 1.66699 7.63628 1.66699 15.0001C1.66699 22.3639 7.63653 28.3334 15.0003 28.3334C22.3641 28.3334 28.3337 22.3639 28.3337 15.0001C28.3337 7.63628 22.3641 1.66675 15.0003 1.66675ZM15.0003 1.66675C12.3337 4.33341 14.3337 9.66675 19.0003 7.00008M9.66699 20.3334C9.66699 20.3334 11.667 23.0001 15.0003 23.0001C18.3337 23.0001 20.3337 20.3334 20.3337 20.3334M21.667 13.6667C21.1403 13.0201 20.4203 12.6534 19.667 12.6534C18.9137 12.6534 18.2137 13.0201 17.667 13.6667M12.3337 13.6667C11.807 13.0201 11.087 12.6534 10.3337 12.6534C9.58033 12.6534 8.88033 13.0201 8.33366 13.6667"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 5,
      name: "Farewell",
      svg: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.3332 12.0001V8.00008C21.3332 5.05456 18.9454 2.66675 15.9998 2.66675C13.0543 2.66675 10.6665 5.05456 10.6665 8.00008V12.0001M4.78918 13.8027L3.98918 22.336C3.76172 24.7623 3.64798 25.9754 4.05057 26.9124C4.40424 27.7356 5.024 28.4162 5.81053 28.8451C6.70588 29.3334 7.92433 29.3334 10.3612 29.3334H21.6384C24.0754 29.3334 25.2938 29.3334 26.1891 28.8451C26.9757 28.4162 27.5954 27.7356 27.9491 26.9124C28.3517 25.9754 28.238 24.7623 28.0105 22.336L27.2105 13.8027C27.0184 11.7539 26.9224 10.7295 26.4616 9.95497C26.0558 9.27286 25.4563 8.7269 24.7393 8.38654C23.9252 8.00008 22.8963 8.00008 20.8384 8.00008L11.1612 8.00008C9.10343 8.00008 8.07452 8.00008 7.2604 8.38654C6.54339 8.72689 5.94385 9.27286 5.53806 9.95496C5.0773 10.7295 4.98126 11.7539 4.78918 13.8027Z"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 6,
      name: "Promotion",
      svg: (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.1673 29.3334H12.2338C9.99371 29.3334 8.87367 29.3334 8.01802 28.8974C7.26537 28.5139 6.65345 27.902 6.26996 27.1494C5.83398 26.2937 5.83398 25.1736 5.83398 22.9334V9.06675C5.83398 6.82654 5.83398 5.70643 6.26996 4.85079C6.65345 4.09814 7.26537 3.48622 8.01802 3.10272C8.87367 2.66675 9.99377 2.66675 12.234 2.66675H20.7673C23.0075 2.66675 24.1276 2.66675 24.9833 3.10272C25.7359 3.48622 26.3478 4.09814 26.7313 4.85079C27.1673 5.70643 27.1673 6.82654 27.1673 9.06675M16.5007 14.6667H11.1673M13.834 20.0001H11.1673M21.834 9.33341H11.1673M28.5006 25.3334L24.5007 21.3334M24.5007 21.3334L20.5007 25.3334M24.5007 21.3334L24.5006 29.3334M28.5006 17.3334L24.5006 13.3334L20.5007 17.3334"
            stroke="#E31B54"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 7,
      name: "Anniversary",
      svg: (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.5 2C22.8674 2.00005 23.222 2.13493 23.4966 2.37907C23.7711 2.62321 23.9465 2.95962 23.9895 3.3245L24 3.5V5H27C27.7569 4.99976 28.4858 5.28561 29.0408 5.80025C29.5958 6.31488 29.9357 7.02027 29.9925 7.775L30 8V26C30.0002 26.7569 29.7144 27.4858 29.1998 28.0408C28.6851 28.5958 27.9797 28.9357 27.225 28.9925L27 29H6C5.24314 29.0002 4.51415 28.7144 3.95918 28.1998C3.40421 27.6851 3.06427 26.9797 3.0075 26.225L3 26V8C2.99976 7.24314 3.28561 6.51415 3.80025 5.95918C4.31488 5.40421 5.02027 5.06427 5.775 5.0075L6 5H9V3.5C9.00042 3.11768 9.14682 2.74995 9.40927 2.47195C9.67173 2.19394 10.0304 2.02665 10.4121 2.00424C10.7938 1.98184 11.1696 2.10601 11.4627 2.3514C11.7559 2.59678 11.9443 2.94486 11.9895 3.3245L12 3.5V5H21V3.5C21 3.10218 21.158 2.72064 21.4393 2.43934C21.7206 2.15804 22.1022 2 22.5 2ZM27 8H6V26H27V8ZM21.249 10.814C22.917 11.786 24.048 13.727 23.9985 15.947C23.937 18.701 21.8835 20.963 18.8415 22.847L18.4725 23.0705C17.868 23.4305 17.2275 23.8325 16.5 23.8325C15.954 23.8325 15.4575 23.6075 14.988 23.3405L14.5275 23.0705C11.283 21.143 9.066 18.8105 9.0015 15.947C8.952 13.727 10.083 11.786 11.751 10.814C13.182 9.98 14.9535 9.9035 16.5 10.8695C18.045 9.9035 19.818 9.98 21.249 10.814ZM19.7385 13.406C19.17 13.076 18.4935 13.037 17.8215 13.61L17.655 13.7675C17.3729 14.0521 16.9957 14.2225 16.5956 14.246C16.1956 14.2696 15.801 14.1446 15.4875 13.895L15.345 13.7675C14.619 13.0325 13.8765 13.0475 13.2615 13.4075C12.57 13.8095 11.9745 14.7125 12.0015 15.8795C12.027 17.0495 12.9285 18.5495 15.7035 20.2745L16.0605 20.4905C16.206 20.5775 16.3515 20.666 16.5 20.7485L16.7205 20.621L16.9395 20.4905C19.9935 18.6755 20.9715 17.0975 20.9985 15.8795C21.0255 14.7125 20.43 13.8095 19.7385 13.406Z"
            fill="#E31B53"
          />
        </svg>
      ),
    },
    {
      id: 8,
      name: "Graduation",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6733 7.41853L3.48033 11.8052C3.33783 11.8665 3.21637 11.9684 3.13102 12.0984C3.04567 12.2284 3.00018 12.3806 3.00018 12.5363C3.00018 12.692 3.04567 12.8442 3.13102 12.9742C3.21637 13.1041 3.33783 13.2061 3.48033 13.2674L13.6733 17.654C14.2959 17.9219 14.9662 18.0599 15.6435 18.0598H16.3595C17.0368 18.0599 17.7071 17.9219 18.3297 17.654L28.5227 13.2674C28.6652 13.2061 28.7866 13.1041 28.872 12.9742C28.9573 12.8442 29.0028 12.692 29.0028 12.5363C29.0028 12.3806 28.9573 12.2284 28.872 12.0984C28.7866 11.9684 28.6652 11.8665 28.5227 11.8052L18.3297 7.41853C17.7071 7.1507 17.0368 7.01267 16.3595 7.01281H15.6435C14.9662 7.01267 14.2959 7.1507 13.6733 7.41853ZM3.00028 16.3364L6.00056 17.6299V24.1135C6.00059 24.8597 6.20757 25.5911 6.5983 26.2257C6.98904 26.8604 7.54808 27.3732 8.21277 27.7068L9.82492 28.5162C11.7463 29.4807 13.8628 29.9883 16.0108 29.9998C18.1588 30.0113 20.2806 29.5264 22.2121 28.5825L24.0303 27.6947C24.7048 27.3652 25.2735 26.8518 25.6713 26.2132C26.0692 25.5747 26.2803 24.8366 26.2805 24.0834V17.5094L29.7048 16.0352C30.3861 15.7412 30.9667 15.2531 31.3746 14.6312C31.7826 14.0093 32 13.281 32 12.5363C32 11.7916 31.7826 11.0633 31.3746 10.4414C30.9667 9.81952 30.3861 9.3314 29.7048 9.03741L19.5118 4.64876C18.5157 4.22036 17.4432 3.99965 16.3595 4H15.6435C14.5598 3.99965 13.4873 4.22036 12.4912 4.64876L2.30022 9.03741C1.61793 9.33064 1.03632 9.81844 0.627453 10.4404C0.218582 11.0623 0.000419658 11.791 0 12.5363L0 21.5747C0 21.9742 0.15805 22.3574 0.439381 22.6399C0.720712 22.9224 1.10228 23.0811 1.50014 23.0811C1.898 23.0811 2.27957 22.9224 2.5609 22.6399C2.84223 22.3574 3.00028 21.9742 3.00028 21.5747V16.3364ZM9.00084 24.1135V18.9214L12.4912 20.4238C13.4873 20.8522 14.5598 21.0729 15.6435 21.0726H16.3595C17.4432 21.0729 18.5157 20.8522 19.5118 20.4238L23.2802 18.8009V24.0834C23.2802 24.272 23.2273 24.4569 23.1275 24.6167C23.0278 24.7766 22.8852 24.905 22.7161 24.9872L20.898 25.875C19.3805 26.616 17.7136 26.9965 16.0262 26.987C14.3388 26.9776 12.6763 26.5786 11.167 25.8208L9.5529 25.0113C9.38699 24.9278 9.24748 24.7996 9.14999 24.6411C9.05249 24.4825 9.00085 24.2999 9.00084 24.1135Z"
            fill="#E31B53"
          />
        </svg>
      ),
    },
  ];

  const getLocation = async () => {
    axios({ url: `https://ipapi.co/json/` })
      .then((res) => {
        // console.log(res.data)
        setEvent((existingValue) => ({
          ...existingValue,
          timeZone: res.data.timezone,
        }));
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (location.state?.fromConnection) {
      console.log("fromConnection");

      setEvent((prev) => ({
        ...prev,
        firstName: location.state.firstName || "",
        lastName: location.state.lastName || "",
        email: location.state.email || "",
        phone: location.state.phoneNumber || "",
        profilePhoto: location.state.profilePhoto || "",
      }));
    }
    if (location.state?.fromNotifications) {
      console.log("fromNotifications");
      console.log(location.state.birthday, "location.state.birthday?");
      //  const currentYear = new Date().getFullYear();
      const finalDate = getEventDate(location.state.date);
      console.log(finalDate, "finalDate");
      console.log(location.state.date, "date");
      setEvent((prev) => ({
        ...prev,
        firstName: location.state.firstName || "",
        lastName: location.state.lastName || "",
        email: location.state.email || "",
        phone: location.state.phoneNumber || "",
        profilePhoto: location.state.profilePhoto || "",
        occasionId: location.state.birthday ? "Birthday" : "Anniversary" || "",
        //  date: `${currentYear}-${location.state.date}` || "",
        date: finalDate,
        eventRawDate: finalDate,
      }));
    }
  }, [location.state, setEvent]);
  console.log(event, "event step 1");
  return (
    <>
      <div className="eventbar">
        <EventHeaderTitle />
        <div className="rangebar">
          <img src="/images/step1.png" alt="step1" />
          <h4>Step 1 of 3</h4>
        </div>
        <Form>
          <Form.Group className="formgroup" controlId="formBasicEmail">
            <Form.Label>Name the gift recipient</Form.Label>
            <div className="usericon">
              <div>
                <Container>
                  <Row>
                    <Col>
                      <div className="formgroup-relative">
                        <svg
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.5 15.6667C3.44649 13.6021 6.08918 12.3333 9 12.3333C11.9108 12.3333 14.5535 13.6021 16.5 15.6667M12.75 5.25C12.75 7.32107 11.0711 9 9 9C6.92893 9 5.25 7.32107 5.25 5.25C5.25 3.17893 6.92893 1.5 9 1.5C11.0711 1.5 12.75 3.17893 12.75 5.25Z"
                            stroke="#667085"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <Form.Control
                          className={errors.firstName ? "error" : ""}
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9 ]*$/;
                            const inputValue = e.target.value;
                            if (regex.test(inputValue)) {
                              handleForm(inputValue, "firstName");
                            }
                          }}
                          value={event?.firstName}
                        />
                      </div>
                      <FieldError error={errors.firstName} />
                    </Col>
                    <Col>
                      <div className="formgroup-relative withoutsvg">
                        <Form.Control
                          className={errors.lastName ? "error" : ""}
                          type="text"
                          Name="lastName"
                          placeholder="Last Name"
                          onChange={(e) => {
                            const regex = /^[a-zA-Z0-9 ]*$/;
                            const inputValue = e.target.value;
                            if (regex.test(inputValue)) {
                              handleForm(inputValue, "lastName");
                            }
                          }}
                          value={event?.lastName}
                        />
                      </div>

                      <FieldError error={errors.lastName} />
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Form.Group>
          <Form.Group className="formgroup" controlId="formBasicEmail">
            <Form.Label>What is the Occasion?</Form.Label>
            <div className="Customcheckbar">
              {occasionList.map((element, index) => (
                <div className="rowbar">
                  <label key={index} className="Customcheck">
                    <Form.Control
                      className={errors.occasionId ? "error" : ""}
                      type="checkbox"
                      name="radio"
                      checked={event?.occasionId === element.name}
                      onChange={(e) => handleOccasionChange(element.name)}
                    />
                    <div className="check-detail">
                      {element.svg}
                      {element.name}
                    </div>
                    <span className="checkmark"></span>
                  </label>
                </div>
              ))}
              <div className="rowbar">
                <label onClick={OtherShow} className="Customcheck">
                  <Form.Control
                    type="checkbox"
                    name="radio"
                    checked={otherOccasion !== ""}
                  />
                  <div className="check-detail">
                    <svg
                      width="31"
                      height="30"
                      viewBox="0 0 31 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.5003 11H19.5137M11.5003 11H11.5137M28.8337 15C28.8337 22.3638 22.8641 28.3333 15.5003 28.3333C8.13653 28.3333 2.16699 22.3638 2.16699 15C2.16699 7.63619 8.13653 1.66666 15.5003 1.66666C22.8641 1.66666 28.8337 7.63619 28.8337 15ZM20.167 11C20.167 11.3682 19.8685 11.6667 19.5003 11.6667C19.1321 11.6667 18.8337 11.3682 18.8337 11C18.8337 10.6318 19.1321 10.3333 19.5003 10.3333C19.8685 10.3333 20.167 10.6318 20.167 11ZM12.167 11C12.167 11.3682 11.8685 11.6667 11.5003 11.6667C11.1321 11.6667 10.8337 11.3682 10.8337 11C10.8337 10.6318 11.1321 10.3333 11.5003 10.3333C11.8685 10.3333 12.167 10.6318 12.167 11ZM15.5003 22.3333C18.8343 22.3333 21.5003 19.8893 21.5003 17.6667H9.50033C9.50033 19.8893 12.1663 22.3333 15.5003 22.3333Z"
                        stroke="#E31B54"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Others
                  </div>
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>

            <FieldError error={errors.occasionId} />
          </Form.Group>
          <DateTimeBox
            errors={errors}
            date={event?.date}
            time={event?.time}
            handleChangeDate={(e) =>
              handleForm(e ? e.toDateString() : null, "date")
            }
            handleChangeTime={(e) => handleForm(e, "time")}
          />
          {/* <div className="started-btn">
            <button className="btngray" onClick={(e) => resetDateTime()}>
              Not Yet Decided
            </button>
          </div> */}
          <div className="groupgift-bluebar">
            <AiOutlineInfoCircle />
            <p>You can select the gift cards after creating the event</p>
          </div>
        </Form>
        <Button className="btn-pink" onClick={eventstate2}>
          Proceed
        </Button>
      </div>

      {/* Others Modals */}
      <Modal
        className="Createevent-modal"
        show={showOtherbar}
        onHide={OtherClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Other</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="CreateEvent-form">
            <BsEmojiSmile />
            <Form>
              <Form.Group className="formgroup" controlId="formBasicEmail">
                <Form.Label>Name the event</Form.Label>
                <Form.Control
                  value={otherOccasion}
                  onChange={(e) => handleOtherOccasion(e?.target?.value)}
                  type="text"
                  placeholder="Enter Event Name"
                />
              </Form.Group>
              <Button className="btn-pink" onClick={OtherClose}>
                Save
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="Createevent-modal"
        show={alertShow}
        onHide={handleClosedateadded}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {new Date(`${event?.date} ${event?.time}`) <
          new Date(Date.now() + 24 * 60 * 60 * 1000)
            ? "There can be potential delivery delays on events scheduled within 24 hrs."
            : `To ensure timely delivery of gift card to recipient,  confirm the order before ${new Date(
                new Date(`${event?.date} ${event?.time}`).getTime() -
                  12 * 60 * 60 * 1000
              )
                .toLocaleString("en-US", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                .replace(
                  "at",
                  "by"
                )}. There can be potential delivery delays on order confirmed after the mentioned time.`}
        </Modal.Body>
        <Modal.Footer>
          <Link type="button" to={"/eventstep2"} className="btn-pink">
            Ok
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EventStep1;
